import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import 'app/shared/material/material-calendar-fallback';
import { environment } from 'environments/environment';

// Register Spanish locale for date pipes
registerLocaleData(localeEs, 'es-ES');

// Log application version and environment
console.log(`%c🍯 HoneyTokens v${environment.version}`, 'color: #ff9800; font-weight: bold; font-size: 14px;');
console.log(`%c🌍 Environment: ${environment.envName}`, 'color: #4caf50; font-weight: bold;');
if (environment.enableDebug) {
    console.log('🔧 Debug mode enabled');
}

bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));
